import { ThemeEvents } from '@theme/events';

/**
 * PDP の獲得予定ポイント表示（#30）。
 *
 * 価格はバリアントで変わるので、バリアント切り替え時に文言を差し替える。
 * ポイントの計算は Liquid 側（`blocks/product-point-yokomo.liquid`）が持っていて、
 * ここは**サーバーが返した新しい HTML から自分の分を取り出して置き換えるだけ**。
 * 還元率やランクの判定を JS に二重で持たない（Liquid と JS でズレる元になる）。
 *
 * 作りはテーマの `<product-price>`（`assets/product-price.js`）と同じ。
 * variant:update は同じ `.shopify-section` の中でしか拾わないので、カード用の
 * スウォッチなど別商品のイベントで書き換わることはない。
 */
class ProductPointYokomo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.#updatePoint);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.#updatePoint);
  }

  /**
   * @param {CustomEvent} event - variant:update イベント
   */
  #updatePoint = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `product-point-yokomo[data-block-id="${this.dataset.blockId}"]`
    );

    // 新しい価格が0円になった等でブロックごと消えたときは、こちらも消す。
    // 残すと切り替え前のポイント数が出たままになる
    if (!newElement) {
      this.remove();
      return;
    }

    const newText = newElement.querySelector('.product-point-yokomo__text');
    const currentText = this.querySelector('.product-point-yokomo__text');
    if (newText && currentText) currentText.replaceWith(newText);
  };
}

if (!customElements.get('product-point-yokomo')) {
  customElements.define('product-point-yokomo', ProductPointYokomo);
}
